module.exports = __webpack_public_path__ + "static/media/BWSICubeSat.94d10760.jpg";